<script lang="typescript">
    export let noLeads = false;
  
    $: win = noLeads ? 'Lead' : 'Win';
  </script>
  
  <div class="legend-holder text-left" aria-hidden="true">
    <div class="party-key">
   
      <div class="mb-11">
        <span class="text-bold">Dem.</span>
      </div>
      <div class="display-flex gap-5">   
        <div>
          <span class="key-color d-win"></span> 
          <div class="mt-7 color-grey">  
            {win} 
          </div>
        </div>
        <div>
          {#if !noLeads}
          <span class="key-color d-lead"></span>
          <div class="mt-7 color-grey">Lead</div>
          {/if} 
        </div>
      </div>  
    </div>

    <div class="party-key">
     <span class="text-bold mb-11 text-left">Rep.</span>
     <div class="display-flex gap-5">
      <div>   
       
        <span class="key-color r-win"></span>
        <div class="mt-7 color-grey">{win}</div>
       
      </div>

      <div>
        {#if !noLeads} 
        <span class="key-color r-lead"></span>
        <div class="mt-7 color-grey">Lead</div>
          {/if}
        
      </div>
     </div>
     
    </div>
    <div class="party-key">  
      <span class="text-bold mb-11">Other</span>
      <div class="display-flex gap-5">
        <div>   
         
          <span class="key-color o-win"></span>
       
          <div class="mt-7 color-grey">{win}</div>
         
        </div>
        <div>
         {#if !noLeads}
         <span class="key-color o-lead"></span> 
         <div class="mt-7 color-grey">Lead</div>
         {/if}
         
        </div>
      </div>
    </div>
    <div class="party-key">
        <span class="text-bold mb-11">Tie</span>
        <div>   
          <span class="key-color tie-win"></span>
        </div>
     
    </div>
    
  </div>